import React, { useEffect, useState } from "react";
import Drawer from "@material-ui/core/Drawer";
import styled from "styled-components";
import { Close } from "@icons";
import { cssVar } from "polished";
import { useTranslation } from "react-i18next";

export const DrawerContent = styled.div`
  width: 513px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 25px;
    border-bottom: var(--thin-border) var(--border-color);

    .title {
      font-size: calc(var(--base-font-size) + 4px);
      font-weight: var(--font-weight-medium);
    }
  }

  .terms_list {
    padding: 17px 23px;
    overflow-y: scroll;
    color: var(--primary-color-3);

    h5 {
      font-weight: var(--font-weight-medium);
    }

    > :not(:last-child) {
      margin-bottom: 20px;
    }

    .box {
      display: flex;
      flex-direction: column;

      .title {
        font-weight: var(--font-weight-medium);
        text-transform: uppercase;
        margin-bottom: 6px;
      }
      .message {
        display: flex;
        flex-direction: column;
        line-height: 24px;

        > :not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }
`;

interface Props {
  status: boolean;
  handleStatus: React.Dispatch<React.SetStateAction<boolean>>;
}

function TermsAndCondn(props: Props) {
  const { status, handleStatus } = props;

  const { t } = useTranslation();

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      handleStatus(open);
    };

  return (
    <>
      <Drawer anchor={"right"} open={status} onClose={toggleDrawer(false)}>
        <DrawerContent>
          <div className="header">
            <p className="title">{t("CON_TERM_CONDITION_TITLE")}</p>
            <Close
              width="12px"
              height="12px"
              onClick={toggleDrawer(false)}
              stroke={`${cssVar("--primary-color-3")}`}
            />
          </div>

          <div className="terms_list">
            <div
              dangerouslySetInnerHTML={{
                __html: `${t("CON_TERM_CONDITION")}`,
              }}
            />
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default TermsAndCondn;
